import { useDispatch, useSelector } from "react-redux";
import { LOADING_SCHOOL, SCHOOLS } from "../store/selectors";
import { useEffect } from "react";
import { App } from "antd";
import {
  setLoading,
  setSchools,
  deleteSchool as deleteSchoolAction,
} from "../store/slices/school";
import {
  getSchools,
  deleteSchool as deleteSchoolService,
  getSchoolById as getSchoolByIdService,
} from "../services/schools/school.service";

export const useSchools = () => {
  // From App.useApp(): the static notification does not render under React 19.
  const { notification } = App.useApp();
  const dispatch = useDispatch();
  const schools = useSelector(SCHOOLS);
  const loading = useSelector(LOADING_SCHOOL);

  const fetchInfo = async () => {
    dispatch(setLoading(true));
    try {
      if (schools?.length > 0) {
        setSchools(schools);
      } else {
        const schoolsResponse = await getSchools();
        schoolsResponse && dispatch(setSchools(schoolsResponse));
      }
      dispatch(setLoading(false));
    } catch (error: any) {
      dispatch(setLoading(false));
      notification["error"]({
        message: "Error",
        description:
          "La información no pudo ser cargada, por favor notifica éste error!",
        placement: "top",
        duration: 3,
      });
      throw new Error(error);
    }
  };

  const getSchoolById = async (id: number) => {
    try {
      const response = await getSchoolByIdService(id);
      return response;
    } catch (error: any) {
      // Caller owns the error UX; rethrow the original error so it can read
      // error.response.data.message.
      console.error("Error getting school by ID:", error);
      throw error;
    }
  };

  const deleteSchool = async (id: number): Promise<boolean> => {
    dispatch(setLoading(true));
    try {
      await deleteSchoolService(id);
      dispatch(deleteSchoolAction(id));
      notification["success"]({
        message: "Éxito",
        description: "La escuela fue eliminada exitosamente!",
        placement: "top",
        duration: 3,
      });
      dispatch(setLoading(false));
      return true;
    } catch (error: any) {
      dispatch(setLoading(false));
      notification["error"]({
        message: "Eliminación Erronea",
        description:
          error?.response?.data?.message || "La escuela no pudo ser eliminada!",
        placement: "top",
        duration: 3,
      });
      return false;
    }
  };

  useEffect(() => {
    fetchInfo();
  }, []);

  return {
    loading,
    schools,
    deleteSchool,
    getSchoolById,
  };
};
